<template>
  <i
    v-if="!confirm"
    class="fa fa-trash xs-font warn-text"
    @click="confirm = true"
  />
  <div
    v-else
    class="xs-font flex wrap align-center"
    :class="msg && 'container p4 between'"
  >
    <p class="warn-text b4" v-if="msg">{{ msg }}</p>
    <a class="m4" @click="confirm = false">Cancel</a>
    <button
      type="button"
      class="warn white p4 xs-font"
      @click="
        rm();
        confirm = false;
      "
    >
      <i class="fa fa-trash r4"></i> Remove {{ title }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    item: { type: Object },
    name: { type: [String, Number, Array] }, // object key or array index
    obj: { type: [Object, Array] },
    fn: { type: Object }, // {command, method, type, data string to parse ($_)}
    msg: { type: String },
    typeconfirm: { type: Boolean },
    title: {type: String}
  },
  data() {
    return {
      confirm: false,
    };
  },
  methods: {
    rm() {
      if (this.typeconfirm) {
        let matchtitle = prompt(`CAUTION: this action is unreversible. Enter [ ${this.title || this.name} ] to delete`)
        if (matchtitle !== (this.title || this.name)) return alert()
        else {
          console.log('matchtitle is true, continue delete proceedure.');
        }
      }
      if (this.item)
        return this.$store.dispatch("delete", {
          type: this.item.type,
          id: this.item.id || this.item.hash,
          name: this.item.name,
        });
      if (Array.isArray(this.obj)) {
        if (Array.isArray(this.name)) {
          this.name.reverse().map((i) => this.obj.splice(i, 1));
        } else this.obj.splice(this.name, 1);
      } else {
        if (Array.isArray(this.name)) {
          this.name.map((i) => this.$delete(this.obj, i));
        } else {
          console.log("object", this.obj, this.name);
          this.$delete(this.obj, this.name);
        }
      }

      if (this.fn) {
        console.log("after fire", this.fn);
        let data = this.fn.data || this.$_.get(this, this.fn.obj);
        let payload = data || {};
        payload.type = this.fn.type;
        return this.$store[this.fn.command](this.fn.method, payload).then(
          (x) => x
        );
      } else {
        return this.obj;
      }
    },
  },
};
</script>

